"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function getCurrentFocusedElement(ref, value) {
  var _ref$current;
  return Array.from(((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll('[role="option"]')) || []).find(function (item) {
    return item.getAttribute('id') === value;
  });
}
function scrollElementIntoView(menuRef, value) {
  if (menuRef.current && menuRef.current.scrollHeight > menuRef.current.clientHeight) {
    var currentFocusedElement = getCurrentFocusedElement(menuRef, value);
    if (currentFocusedElement) {
      var scrollBottom = menuRef.current.clientHeight + menuRef.current.scrollTop;
      var elementBottom = currentFocusedElement.offsetTop + currentFocusedElement.offsetHeight;
      if (elementBottom > scrollBottom) {
        menuRef.current.scrollTop = elementBottom - menuRef.current.clientHeight;
      } else if (currentFocusedElement.offsetTop < menuRef.current.scrollTop) {
        menuRef.current.scrollTop = currentFocusedElement.offsetTop;
      }
    }
  }
}
var _default = scrollElementIntoView;
exports["default"] = _default;
//# sourceMappingURL=scrollElementIntoView.js.map